const LAST_SESSION_PROVIDERS = {
  EMAIL: 'email'
}

export default LAST_SESSION_PROVIDERS
